module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/recruit_bg-912bd86ab2562542c915813f2a3efa3d.png";